const url = '/api/v1/gradebook/';

export const state = {
    gradebook_partners: [],
    gradebook_partner: null,
    gradebook_groups: [],
    gradebook_group: null,
    gradebook_programs: [],
    gradebook_program: null,
    gradebook_modules: [],
    gradebook_module: null,
    gradebook_lesson_id: null,
    gradebook_limit: '',
    gradebook_student_id: '',

    dashboard_chosen_data: null,

    students: null,
    lessons: null,
    current_user: null,

    limits: [],
    limitsTeacher: [],
}, modules = {
    loading: 'loading', alert: 'alert',
}

export const getters = {
    gradebook_partners: state => state.gradebook_partners,
    gradebook_partner: state => state.gradebook_partner,
    gradebook_groups: state => state.gradebook_groups,
    gradebook_group: state => state.gradebook_group,
    gradebook_programs: state => state.gradebook_programs,
    gradebook_program: state => state.gradebook_program,
    gradebook_modules: state => state.gradebook_modules,
    gradebook_module: state => state.gradebook_module,
    gradebook_lesson_id: state => state.gradebook_lesson_id,
    gradebook_limit: state => state.gradebook_limit,
    gradebook_student_id: state => state.gradebook_student_id,

    dashboard_chosen_data: state => state.dashboard_chosen_data,

    students: state => state.students,
    lessons: state => state.lessons,
    current_user: state => state.current_user,

    limits: state => state.limits,
    limitsTeacher: state => state.limitsTeacher,
}

export const mutations = {
    setData(state, {type, items}) {
        state[type] = items;
    },

    clearData(state, {types}) {
        for (let key in state) {
            for (let type in types) {
                key === types[type] ? state[key] = null : false
            }
        }
    }
}

export const actions = {
    async getPartners({commit, dispatch}) {
        dispatch('loading/addLoading', '', {root: true})
        const { data: items } = await axios.get(url + 'get-partners');
        dispatch('loading/subLoading', '', {root: true})
        commit('setData', {type: 'gradebook_partners', items: [...items] });
    },

    getChoosenArray({commit}, items) {
        commit('setData', {type: 'dashboard_chosen_data', items});
    },

    async setPartner({commit, state, dispatch}, item) {
        if (item) {
            commit('setData', {type: 'gradebook_partner', items: item});
            commit("clearData", {
                types: ['lessons', 'students', 'gradebook_group', 'gradebook_program', 'gradebook_programs', 'gradebook_groups']
            })

            dispatch('loading/addLoading', '', {root: true})
            const {data: items} = await axios.get(url + 'get-groups-by-partner/' + item.id);
            dispatch('loading/subLoading', '', {root: true})
            commit('setData', {
                // module: 'adminGradebook',
                type: 'gradebook_groups',
                items: items
            });
        } else {
            commit('setData', {type: 'gradebook_partner', items: false});

            commit('setData', {type: 'gradebook_group', items: false});
            commit('setData', {type: 'gradebook_groups', items: []});

            commit('setData', {type: 'gradebook_program', items: false});
            commit('setData', {type: 'gradebook_programs', items: []});

            commit('setData', {type: 'students', items: false});
            commit('setData', {type: 'lessons', items: false});
            commit('setData', {type: 'current_user', items: false});
        }
    },

    async setGroup({commit, state, dispatch}, item) {
        if (item) {
            commit('setData', {type: 'gradebook_group', items: item});
            commit("clearData", {types: ['lessons', 'students']});

            dispatch('loading/addLoading', '', {root: true})
            const {data: items} = await axios.get(url + 'get-programs-by-group/' + item.id);
            dispatch('loading/subLoading', '', {root: true})

            commit('setData', {type: 'gradebook_programs', items: items});
            commit('setData', {type: 'gradebook_program', items: false});
        } else {
            commit("clearData", {types: ['gradebook_group', 'gradebook_program', 'gradebook_programs', 'students', 'lessons', 'current_user']});
        }
    },

    async setProgram({commit, state, dispatch}, item = false) {
        commit('setData', {type: 'gradebook_program', items: item});
        if (item) {

            dispatch('loading/addLoading', '', {root: true})
            const {data: items} = await axios.get(url + 'get-modules-by-program/' + item.id);
            dispatch('loading/subLoading', '', {root: true})

            dispatch('auth/hasRole', 'Administrator', {root: true}).then((r) => {
                if (r) {
                    dispatch('getTable')
                }
            })
            dispatch('auth/hasRole', 'Tutor', {root: true}).then((r) => {
                if (r) {
                    dispatch('getTable')
                }
            })

            commit('setData', {type: 'gradebook_modules', items: items});
            commit('setData', {type: 'gradebook_module', items: false});
        } else {
            commit("clearData", {types: ['limits', 'students', 'lessons', 'current_user', 'gradebook_module']});
        }
    },

    async setModule({commit, state, dispatch}, item = false) {
        commit('setData', {type: 'gradebook_module', items: item});
        if (item) {
            dispatch('getTable')
        } else {
            commit("clearData", {types: ['limits', 'students', 'lessons', 'current_user']});
        }
    },

    async setLessonId({commit, state, dispatch}, id) {
        commit('setData', {type: 'gradebook_lesson_id', items: id});
    },

    async setStudentId({commit, state, dispatch}, id) {
        commit('setData', {type: 'gradebook_student_id', items: id});
    },

    async setLimitsTeacher({commit, state, dispatch}, id) {
        commit('setData', {type: 'limitsTeacher', items: id});
    },

    async getTable({commit, state, dispatch}, limit = '') {

        try {
            let url_full =  url + 'get-gradebook' + state.gradebook_limit;
            if (limit) {
                url_full = url + 'get-gradebook' + limit;
                commit('setData', {type: 'gradebook_limit', items: limit})
            } else if (Object.keys(state.limitsTeacher).length > 0){
                url_full = url + 'get-gradebook' + state.limitsTeacher;
                commit('setData', {type: 'gradebook_limit', items: state.limitsTeacher})
            }

            dispatch('loading/addLoading', '', {root: true})
            const {data: {students, lessons, current_user, limits}} = await axios.post(url_full, {
                group_id: state.gradebook_group.id,
                program_id: state.gradebook_program.id,
                module_id: state.gradebook_module ? state.gradebook_module.id : null,
                lesson_id: state.gradebook_lesson_id ?? null,
            });
            dispatch('loading/subLoading', '', {root: true})

            commit('setData', {type: 'limits', items: limits});
            commit('setData', {type: 'students', items: students});
            commit('setData', {type: 'lessons', items: lessons});
            commit('setData', {type: 'current_user', items: current_user});
        } catch (e) {
            commit("clearData", {types: ['limits', 'students', 'lessons', 'current_user']});
        }
    },

    // todo: need do clearData between modules
    clearAllData({commit}) {
        commit("clearData", {types: ['limits', 'students', 'lessons', 'current_user', 'gradebook_module', 'gradebook_program', 'gradebook_group', 'gradebook_partner']});
    }
};
